export const fieldClass =
  "w-full rounded-xl border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-cyan-500";
export const labelClass = "mb-1.5 block text-sm font-medium text-slate-300";
